import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EstadoFaseAnualModel, ResponseEstadoFaseAnualModel } from 'src/app/model/EstadoFaseAnual.model';
import { ResponseUnidadEducativaModel, UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewPlanMejoraService } from 'src/app/service/newPlanMejora.service';
import { NewPlanMejoraModel } from 'src/app/model/NewFaseEstrategica.model copy';
import { NewFaseAnual, ResponseNewFaseAnual } from 'src/app/model/NewFaseAnual.model';
import { StorageService } from 'src/app/service/storage.service';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from 'src/app/components/alert-dialog/alert-dialog.component';
@Component({
  selector: 'app-new-pme',
  templateUrl: './new-pme.component.html',
  styleUrls: ['./new-pme.component.css']
})
export class NewPmeComponent implements OnInit {


  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  @ViewChild('modalSeleecionInforme', { static: true }) modalSeleecionInforme: TemplateRef<any>;
  @Input() simulacion: boolean;
  public componente:string="";
  uniEducativa = new UnidadEducativaModel(); 
  dataJardin = new JardinModel();
  cargando = true;
  pme : NewPlanMejoraModel;
  estadoFaseAnual = new  EstadoFaseAnualModel();
  urlInformeExcelPME1 : string = "";
  urlInformeExcelPME2 : string = "";
  urlInformeExcelPME3 : string = "";
  urlInformeExcelPME4 : string = "";
  faseAnualData = new NewFaseAnual();
  spinnerRef:any;

  apiEndpoint = environment.apiEndpoint;

  url:string ;
  urlSafe: SafeResourceUrl;
  
  constructor(
      private api: apiService,
      private newPlanMejoraService: NewPlanMejoraService,
      private modal: NgbModal,
      public sanitizer: DomSanitizer,
       private storageService: StorageService,
       private spinnerService: SpinnerService,
       public dialog: MatDialog,
    ) { }

    ngOnInit(): void {     
      this.componente="";
      this.cargando = true;
      this.dataJardin = this.api.dataJardin;
      this.urlInformeExcelPME1 =  environment.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/";
      this.urlInformeExcelPME2 =  environment.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/";
      this.urlInformeExcelPME3 =  environment.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/";
      this.urlInformeExcelPME4 =  environment.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/";
      this.cargaInicial();
    }
  
    cargaInicial(){
      this.unidadEducativa(this.dataJardin);
      this.getPlanMejora(this.dataJardin);
    
    }

  irA(vista){
    this.componente = vista;
  }

  unidadEducativa(dataJardin:JardinModel){
    this.api.API_POST_obtenerUnidadEducatica(dataJardin.id).subscribe((response: ResponseUnidadEducativaModel) => {
      this.uniEducativa = response.payload;  
    },
    (err) => {
      console.log(err)
    });      
  }


  getPlanMejora(dataJardin:JardinModel){
    this.newPlanMejoraService.API_GET_getNewPlanMejora(dataJardin.idJardinPeriodo).subscribe((response: any) => {
      this.pme = response.payload;  
      if(this.pme.estado > 2){
        this.getFaseAnual(dataJardin);
      }
      this.cargando = false;
    },
    (err) => {
      console.log(err)
    });      
  }


  getFaseAnual(dataJardin: JardinModel) {
    this.newPlanMejoraService.API_GET_getFaseAnual(dataJardin.idJardinPeriodo).subscribe((response: ResponseNewFaseAnual) => {
      this.faseAnualData = response.payload;
      this.faseAnualData.periodos.forEach(periodo => {
        if (periodo.orden == 1){
          this.urlInformeExcelPME1 =  this.urlInformeExcelPME1 + periodo.idPeriodo;
        } else if (periodo.orden == 2){
          this.urlInformeExcelPME2 =  this.urlInformeExcelPME2 + periodo.idPeriodo;
        } else if (periodo.orden == 3){
          this.urlInformeExcelPME3 =  this.urlInformeExcelPME3 + periodo.idPeriodo;
        }else if (periodo.orden == 4){
          this.urlInformeExcelPME4 =  this.urlInformeExcelPME4 + periodo.idPeriodo;
        }
      });
    },
      (err) => {
        console.log(err)
      });
  }
  
  close(){
    this.modal.dismissAll();
  }

  seleccionarPeriodo(){
    this.modal.open(this.modalSeleecionInforme, { size: 'xl' });
  }

  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    //this.menuMostrar = this.storageService.getMenuActivo();
  }

  downloadExcel(anio : string) {
    this.spinnerRef = this.spinnerService.start();
    this.modal.dismissAll();
    this.api.API_GET_downloadExcel( this.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo+ "/"+anio ).subscribe((response: any) => {
      
      FileSaver.saveAs(response,'PME.xls')
      this.spinnerService.stop(this.spinnerRef);
      this.modal.dismissAll();
    },
        (err) => {
          this.spinnerService.stop(this.spinnerRef);
          this.dialog.open(AlertDialog, {
            data: {
              icon: 'Error',
              message: 'Documento no disponible para descargar.'
            }
          });
          console.log(err);
        }); 

}

}
